import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import GradeGroupManagement from '../modules/grade-group-management/GradeGroupManagement'
import TransportManagement from '../modules/transport-management/TransportManagement'
import StateManagement from '../modules/state-management/StateManagement'
import AddInquiry from '../modules/inquiry-management/AddInquiry'
import ViewInquiry from '../modules/inquiry-management/ViewInquiry'
import AddSeller from '../modules/seller-management/AddSeller'
import ViewSeller from '../modules/seller-management/ViewSeller'
import DistrictListing from '../modules/district-management/DistrictListing'
import InvoiceManagement from '../modules/invoice-management/InvoiceManagement'
import AddPurchaseOrder from '../modules/purchase-order/AddPurchaseOrder'
import ViewPurchaseOrder from '../modules/purchase-order/ViewPurchaseOrder'
import AddQuotation from '../modules/quotation-management/AddQuotation'
import ViewQuotation from '../modules/quotation-management/ViewQuotation'
import ViewBuyer from '../modules/buyer-management/ViewBuyers'
import AddBuyer from '../modules/buyer-management/AddBuyer'
import EditBuyer from '../modules/buyer-management/EditBuyer'
import Report from '../modules/report/Report'
import EditSeller from '../modules/seller-management/EditSeller'
import AddProduct from '../modules/product-management/AddProduct'
import ViewProduct from '../modules/product-management/ViewProduct'
import EditProduct from '../modules/product-management/EditProduct'
import { Setting } from '../modules/settings/setting'
import EditInquiry from '../modules/inquiry-management/EditInquiry'
import EditQuotation from '../modules/quotation-management/EditQuotation'
import Location from '../modules/masters/locations/Location'
import EditPurchaseOrder from '../modules/purchase-order/EditPurchaseOrder'
import NewsContentManagement from '../modules/news-content/NewsContentManagement'
import AddArticleForm from '../modules/news-content/news-articles/AddArticle'
import EditArticle from '../modules/news-content/news-articles/EditArticle'
import AddCategory from '../modules/news-content/news-category/AddCategory'
import OfferWithPrice from '../modules/offer-with-price/OfferWithPrice'
import SellerMessage from '../modules/seller-message-module/SellerMessage'
import MultipalOffer from '../modules/multiple-offer-management/MultipalOffer'
import AllOfferWithPrice from '../modules/all-offer-with-price/AllOffersWithPrice'
import BuyerWiseInquiryPrice from '../modules/buyer-wise-inquiry-price/BuyerWiseInquiryPrice'
import Disable2faPage from '../modules/auth/components/Disable2FaPage'
import SellerOffersPage from '../modules/seller-offer-management/SellerOffersPage'
import { RolesList } from '../modules/role-management/roles-list/RolesList'
import RolesPage from '../modules/masters/roles/RolesPage'
import AddRole from '../modules/role-management/AddRole'
import ViewRole from '../modules/role-management/ViewRole'
import { ProductRoute } from './ProductRoute'
import { checkPermission } from 'app/utils/checkPermission'
// import TransporterDetailsPage from '../../pages/TransporterDetails/TransporterDetailsPage'
import QuantityProfitPage from '../modules/product-group-management/QuantityProfitPage'
import BannersPage from '../modules/masters/banners/BannersPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const SufalamsPage = lazy(() => import('../modules/sufalam-management/SufalamsPage'))
  const BuyersPage = lazy(() => import('../modules/buyer-management/BuyersPage'))
  const SellersPage = lazy(() => import('../modules/seller-management/SellersPage'))
  const ProductsPage = lazy(() => import('../modules/product-management/ProductsPage'))
  const UsersPage = lazy(() => import('../modules/masters/users/UsersPage'))
  const OffersPage = lazy(() => import('../modules/offer-management/OffersPage'))
  const InquiriesPage = lazy(() => import('../modules/inquiry-management/InquiriesPage'))
  const QuotationsPage = lazy(() => import('../modules/quotation-management/QuotationsPage'))
  const TransportsPage = lazy(() => import('../modules/masters/transports/TransportsPage'))
  const PurchasesPage = lazy(() => import('../modules/purchase-order/PurchasesPage'))
  const GradesPage = lazy(() => import('../modules/grade-group-management/GradesPage'))
  const FreightsPage = lazy(() => import('../modules/freight-management/FreightsPage'))
  const CopyFreightsPage = lazy(() => import('../modules/copy-freight-management/CopyFreightsPage'))
  const BuyerSellersPage = lazy(
    () => import('../modules/report/buyerseller-report/BuyersellersPage')
  )
  const OrdersPage = lazy(() => import('../modules/report/order-report/OrdersPage'))
  const InquirysPage = lazy(() => import('../modules/report/inquiry-invoice-analysis/InquirysPage'))
  const InvoicesPage = lazy(() => import('../modules/report/invoice-report/InvoicesPage'))
  const SelleroffersPage = lazy(
    () => import('../modules/report/seller-offer-report/SelleroffersPage')
  )
  const GradegroupsPage = lazy(() => import('../modules/report/grade-group-report/GradegroupsPage'))
  const ProductGroupsPage = lazy(
    () => import('../modules/product-group-management/ProductsGroupPage')
  )
  const ExpireOffersPage = lazy(
    () => import('../modules/report/near-expire-offer/ExpireOffersPage')
  )
  const ActiveinquiriesPage = lazy(
    () => import('../modules/report/active-inquiry-report/ActiveinquiriesPage')
  )
  const CompleteinquiriesPage = lazy(
    () => import('../modules/report/complete-inquiry-report/CompleteinquiriesPage')
  )
  const UserinquiriesPage = lazy(
    () => import('../modules/report/userwise-inquiry-report/UserinquiriesPage')
  )
  const LogisticPage = lazy(
    () => import('../modules/report/logistic-report/LogisticPage')
  )
  const MessagesPage = lazy(() => import('../modules/message-management/MessagePage'))
  const AtriclesPage = lazy(() => import('../modules/news-content/news-articles/ArticlesPage'))
  const CatesPage = lazy(() => import('../modules/news-content/news-category/CatesPage'))
  const TransporterDetailsPage = lazy(() => import('../modules/transporter-details-management/TransporterDetailsPage'))
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {/* {checkPermission('Offers', 'list') && (
        )} */}
        <Route path='auth/*' element={<Navigate to='/offer-management/offers' />} />

        <Route path='webpage-seller/*' element={
          // <SuspensedView>
          <SellerOffersPage />
          // </SuspensedView>
          // <h1>Create</h1>
        } />
        {/* Pages */}
        {/* <Route path="" element={<AdminRoute />}> */}
        <Route path='disable/login/security' element={<Disable2faPage />} />
        {checkPermission('Dashboard', 'view') && (
          <Route path='dashboard' element={<DashboardWrapper />} />
        )}
        {/* <Route path='setting' element={<Setting />} /> */}
        {/* <Route path='masters/locations' element={<Location />} /> */}
        
        {checkPermission('Roles', 'create') && (
          <Route path='role-management/add' element={<AddRole />} />
        )}
        {checkPermission('Roles', 'list') && (
        <Route path='role-management/roles' element={<RolesList />} />
        )}
        {checkPermission('Roles', 'view') && (
        <Route path='role-management/roles/view/:id' element={<ViewRole />} />
        )}
        {/* </Route> */}

        {/* <Route path="" element={<AdminRoute />}> */}
        {
          // Buyer and Seller Crud Private Routes
          <>
            {checkPermission('Buyers', 'view') && (
              <Route path='viewbuyer/:id' element={<ViewBuyer />} />
            )}
            {checkPermission('Buyers', 'create') && (
              <Route path='addbuyer' element={<AddBuyer />} />
            )}

            {checkPermission('Buyers', 'edit') && (
              <Route path='editbuyer/:id' element={<EditBuyer />} />
            )}

            {checkPermission('Sellers', 'create') && (
              <Route path='addseller' element={<AddSeller />} />
            )}

            {checkPermission('Sellers', 'edit') && (
              <Route path='editseller/:id' element={<EditSeller />} />
            )}
            {checkPermission('Sellers', 'view') && (
              <Route path='viewseller/:id' element={<ViewSeller />} />
            )}
            {checkPermission('Products', 'create') && (
              <Route path='addproduct' element={<AddProduct />} />
            )}
            {checkPermission('Products', 'edit') && (
              <Route path='editproduct/:id' element={<EditProduct />} />
            )}
            {checkPermission('Products', 'view') && (
              <Route path='viewproduct/:id' element={<ViewProduct />} />
            )}



          </>

        }
        {/* </Route> */}
        {

          <>
            {checkPermission('Inquiries', 'create') && (
              <Route path='addinquiry' element={<AddInquiry />} />
            )}
            {checkPermission('Inquiries', 'edit') && (
              <Route path='editinquiry/:id' element={<EditInquiry />} />
            )}
            {checkPermission('Inquiries', 'view') && (
              <>
                { /* //showing blank view inquiry page therefor below route is commented  */}
                {/* <Route path='viewinquiry' element={<ViewInquiry />} /> */}
                <Route path='viewinquiry/:id' element={<ViewInquiry />} />
              </>

            )}
            {/* <Route path='viewinquiry' element={<ViewInquiry />} /> */}

            {checkPermission('Purchase orders', 'create') && (
              <Route path='addpurchase' element={<AddPurchaseOrder />} />
            )}

            {checkPermission('Purchase orders', 'view') && (
              <Route path='viewpurchase/:id' element={<ViewPurchaseOrder />} />
            )}
            {checkPermission('Purchase orders', 'edit') && (
              <Route path='editpurchase/:id' element={<EditPurchaseOrder />} />
            )}
            {checkPermission('Quotations', 'create') && (
              <Route path='addquotation' element={<AddQuotation />} />
            )}
            {checkPermission('Quotations', 'view') && (
              <Route path='viewquotation/:id' element={<ViewQuotation />} />
            )}
            {checkPermission('Quotations', 'edit') && (
              <Route path='editquotation/:id' element={<EditQuotation />} />
            )}



          </>

        }
        {/* <Route path="" element={<LeaderRoute />}> */}
        {checkPermission('Copy Freights', 'transporter_charge_remort') && (
        // <Route path="transporter-details/:source/:destination" element={<TransporterDetailsPage />} />

         <Route
            path='transporter-details/:source/:destination'
            element={
              <SuspensedView>
                <TransporterDetailsPage />

              </SuspensedView>
            }
          />)}
       
        <Route path='district-management' element={<DistrictListing />} />
        {checkPermission('News Articles', 'create') && (
          <Route path='addarticle' element={<AddArticleForm />} />
        )}
        {checkPermission('News Articles', 'edit') && (
          <Route path='editarticle/:id' element={<EditArticle />} />

        )}
        <Route path='addcategory' element={<AddCategory />} />
        <Route path='report' element={<Report />} />

        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='add-grade-group' element={<GradeGroupManagement />} />
        {/* <Route path='freight-management' element={<FreightManagement />} /> */}
        <Route path='transport-management' element={<TransportManagement />} />
        <Route path='state-management' element={<StateManagement />} />
        <Route path='invoice-management' element={<InvoiceManagement />} />
        <Route path='news-content' element={<NewsContentManagement />} />
        {/* </Route> */}
        {checkPermission('Quantity Wise Profit', 'list') && (
        <Route path='quantity-profit' element={<QuantityProfitPage />} />)}
        {/* <Route path="" element={<AdminRoute />}> */}
        {checkPermission('Settings', 'view') && (
          <Route path='setting' element={<Setting />} />
        )}
        {checkPermission('Locations', 'view') && (
          <Route path='masters/locations' element={<Location />} />
        )}
        {checkPermission('Banners', 'list') && (
          <Route path='masters/banners' element={<BannersPage />} />
        )}
        {/* </Route> */}

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        {(checkPermission('Users', 'list')) && (
          <Route
            path='masters/users/*'
            element={
              <SuspensedView>
                <UsersPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('Transporters', 'list') && (
          <Route
            path='masters/transports/*'
            element={
              <SuspensedView>
                <TransportsPage />
              </SuspensedView>
            }
          />)}

        <Route
          path='sufalam-management/*'
          element={
            <SuspensedView>
              <SufalamsPage />
            </SuspensedView>
          }
        />

        {/* {(checkPermission('Inquiries', 'list') || checkPermission('Quotations', 'list') || checkPermission('Purchase orders', 'list') || checkPermission('Buyers', 'list') || checkPermission('Sellers', 'list')) && ( */}
        {(checkPermission('Inquiries', 'list')) && (
          <>
            <Route
              path='inquiry-management/*'
              element={
                <SuspensedView>
                  <InquiriesPage />
                </SuspensedView>
              }
            />
          </>
        )}
        {checkPermission('Buyers', 'list') && (
          <Route
            path='buyer-management/*'
            element={
              <SuspensedView>
                <BuyersPage />
              </SuspensedView>
            }
          />
        )}
        {(checkPermission('Sellers', 'list')) && (
          <Route
            path='seller-management/*'
            element={
              <SuspensedView>
                <SellersPage />
              </SuspensedView>
            }
          />
        )}
        {(checkPermission('Quotations', 'list')) && (
          <Route
            path='quotation-management/*'
            element={
              <SuspensedView>
                <QuotationsPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('Purchase orders', 'list') && (
          <Route
            path='purchase-order/*'
            element={
              <SuspensedView>
                <PurchasesPage />
              </SuspensedView>
            }
          />
        )}

        {/* 
        <Route path="" element={<LeaderRoute />}>
        </Route> */}
        {/* <Route path="" element={<AdminRoute />}> */}
        <Route
          path='product-management/*'
          element={
            <ProductRoute>
              <SuspensedView>
                <ProductsPage />
              </SuspensedView>
            </ProductRoute>
          }
        />
        {/* </Route> */}

        {/* <Route path="" element={<LogisticRoute />}> */}
        {checkPermission('Offers', 'list') && (

          <Route
            path='offer-management/*'
            element={
              <SuspensedView>
                <OffersPage />

              </SuspensedView>
            }
          />)}

        {/* </Route> */}
        {checkPermission('Offer With Price', 'list') ? (
          <Route
            path='offer-with-price'
            element={
              // <SuspensedView>
              <OfferWithPrice />
              // </SuspensedView>
            }
          />) : ""}

        {checkPermission('Seller Messaging Module', 'list') ?
          <Route
            path='seller-message-module'
            element={
              // <SuspensedView>
              <SellerMessage />
              // </SuspensedView>
            }
          /> : ""}

        {checkPermission('Multiple Offer With Price', 'list') ?
          <Route
            path='multiple-offer-with-price'
            element={
              // <SuspensedView>
              <MultipalOffer />
              // </SuspensedView>
            }
          /> : ""}

        {checkPermission('Lowest Price Offers For All Product Groups', 'list') ?
          <Route
            path='product-group-offer-price'
            element={
              // <SuspensedView>
              <AllOfferWithPrice />
              // </SuspensedView>
            }
          /> : ""}

        {checkPermission('Buyer Wise Inquiry Price', 'list') ?
          <Route
            path='buyer-wise-inquiry-price'
            element={
              // <SuspensedView>
              <BuyerWiseInquiryPrice />
              // </SuspensedView>
            }
          /> : ""}

        {checkPermission('Grade Groups', 'list') ?

          <Route
            path='grade-group-management/*'
            element={
              <SuspensedView>
                <GradesPage />
              </SuspensedView>
            }
          /> : ""}
        {checkPermission('Product Groups', 'list') ?
          <Route
            path='product-group-management/*'
            element={
              <SuspensedView>
                <ProductGroupsPage />
              </SuspensedView>
            }
          /> : ""}


        {
          <>
            {checkPermission('Usage Analysis', 'view') && (
              <Route
                path='buyerseller-report/*'
                element={
                  <SuspensedView>
                    <BuyerSellersPage />
                  </SuspensedView>
                }
              />
            )}
            {checkPermission('Order Duration Analysis', 'view') && (
              <Route
                path='order-report/*'
                element={
                  <SuspensedView>
                    <OrdersPage />
                  </SuspensedView>
                }
              />
            )}
            {checkPermission('Inquiry to Invoice Analysis', 'view') && (
              <Route
                path='inquiry-report/*'
                element={
                  <SuspensedView>
                    <InquirysPage />
                  </SuspensedView>
                }
              />
            )}
          </>}

        <>
          {/* <Route
            path='freight-management/*'
            element={
              <SuspensedView>
                <FreightsPage />
              </SuspensedView>
            }
          /> */}
          {checkPermission('Copy Freights', 'list') && (
            <Route
              path='copy-freight-management/*'
              element={
                <SuspensedView>
                  <CopyFreightsPage />
                </SuspensedView>
              }
            />
          )}
        </>


        <Route
          path='invoice-report/*'
          element={
            <SuspensedView>
              <InvoicesPage />
            </SuspensedView>
          }
        />

        <Route
          path='seller-offer-report/*'
          element={
            <SuspensedView>
              <SelleroffersPage />
            </SuspensedView>
          }
        />
        {/* <Route path="" element={<AdminRoute />}> */}
        {checkPermission('Grade Group Wise Report', 'view') && (
          <Route
            path='grade-group-report/*'
            element={
              <SuspensedView>
                <GradegroupsPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('News Articles', 'list') && (
          <Route
            path='/news-articles/*'
            element={
              <SuspensedView>
                <AtriclesPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('Category', 'list') && (
          <Route
            path='/news-category/*'
            element={
              <SuspensedView>
                <CatesPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('Near to Expiry Offers', 'view') && (
          <Route
            path='near-expire-offer/*'
            element={
              <SuspensedView>
                <ExpireOffersPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('Active Inquiries', 'view') && (
          <Route
            path='active-inquiry-report/*'
            element={
              <SuspensedView>
                <ActiveinquiriesPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('Recently Completed Inquiries', 'view') && (
          <Route
            path='complete-inquiry-report/*'
            element={
              <SuspensedView>
                <CompleteinquiriesPage />
              </SuspensedView>
            }
          />
        )}
        {checkPermission('User Wise Inquiry', 'view') && (
          <Route
            path='userwise-inquiry-report/*'
            element={
              <SuspensedView>
                <UserinquiriesPage />
              </SuspensedView>
            }
          />
        )}
        {/* </Route> */}
        {checkPermission('Operation Report', 'view') && (
          <Route
            path='operation-report/*'
            element={
              <SuspensedView>
                <LogisticPage />
              </SuspensedView>
            }
          />
        )}
        <Route path='role-management'>
          <Route index element={<RolesPage />} />
          <Route path='roles'>
            {checkPermission('Roles', 'list') && (
              <Route index element={<RolesPage />} />
            )}
            {checkPermission('Roles', 'create') && (
              <Route path='add' element={<AddRole />} />
            )}
            {checkPermission('Roles', 'edit') && (
              <Route path='edit/:id' element={<AddRole />} />
            )}
            {checkPermission('Roles', 'view') && (
              <Route path='view/:id' element={<ViewRole />} />
            )}
          </Route>
        </Route>

        <Route path='masters'>
          {checkPermission('Roles', 'list') && (
            <Route path='roles' element={<RolesPage />} />
          )}
          {checkPermission('Roles', 'create') && (
            <Route path='roles/add' element={<AddRole />} />
          )}

          {checkPermission('Roles', 'edit') && (
            <Route path='roles/edit/:id' element={<AddRole />} />
          )}


        </Route>

        {/* Message Management Routes */}
        {checkPermission('Message Logs', 'list') && (
        <Route
            path='message-management/*'
            element={
              <SuspensedView>
                <MessagesPage />
              </SuspensedView>
            }
          />
        )}
        {/* {checkPermission('Messages', 'list') && (
          <Route
            path='message-management/*'
            element={
              <SuspensedView>
                <MessagesPage />
              </SuspensedView>
            }
          />
        )} */}

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
